import { Info, ExternalLink } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";
import { PRODUCTS, TELEGRAM_URL } from "@/config";

function ProductCard({ p, i }) {
    const onMove = (e) => {
        const r = e.currentTarget.getBoundingClientRect();
        e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
        e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
    };
    return (
        <Reveal delay={(i % 3) * 0.1} className="h-full">
            <article
                onMouseMove={onMove}
                data-testid={`offer-card-${p.id}`}
                className="spotlight group flex h-full flex-col overflow-hidden rounded-3xl border border-ink/5 bg-white shadow-[0_10px_30px_-10px_rgba(11,18,32,0.07)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-18px_rgba(11,18,32,0.2)]"
            >
                <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
                    <img
                        src={p.img}
                        alt={p.name}
                        loading="lazy"
                        decoding="async"
                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                    />
                    <span className="absolute left-4 top-4 rounded-full bg-ink px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.18em] text-white shadow-lg" data-testid={`offer-badge-${p.id}`}>
                        Offerta
                    </span>
                    <span className="absolute right-4 top-4 rounded-full bg-flame px-3 py-1 text-sm font-extrabold text-white shadow-lg" data-testid={`offer-discount-${p.id}`}>
                        {p.discount}
                    </span>
                </div>

                <div className="flex flex-1 flex-col p-5 sm:p-6">
                    <span className="font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-telegram-deep">
                        {p.category}
                    </span>
                    <h3 className="mt-2 font-display text-[17px] font-semibold leading-snug tracking-tight text-ink">
                        {p.name}
                    </h3>
                    <div className="mt-3 flex flex-wrap items-baseline gap-x-2.5 gap-y-1">
                        <span className="text-[15px] text-slate-400 line-through">{p.oldPrice}</span>
                        <span className="font-display text-2xl font-bold tracking-tight text-ink">{p.price}</span>
                    </div>
                    <a
                        href={TELEGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`offer-card-${p.id}-button`}
                        className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-telegram-light py-3 text-[13px] font-bold tracking-wide text-telegram-deep ring-1 ring-telegram/25 transition-all duration-300 hover:bg-telegram hover:text-white hover:shadow-[0_14px_30px_-10px_rgba(34,158,217,0.5)]"
                    >
                        <ExternalLink className="h-4 w-4" />
                        VEDI OFFERTA
                    </a>
                </div>
            </article>
        </Reveal>
    );
}

export default function Offers() {
    return (
        <section id="offerte" data-testid="offerte" className="scroll-mt-24 bg-white py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    eyebrow="Offerte in evidenza"
                    title="Alcune delle offerte che potresti trovare"
                    sub="Esempi generici a scopo dimostrativo: nel canale trovi le offerte vere, aggiornate ogni giorno."
                />

                <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {PRODUCTS.map((p, i) => (
                        <ProductCard key={p.id} p={p} i={i} />
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <p
                        className="mt-10 flex items-center justify-center gap-2 text-center text-sm text-slate-400"
                        data-testid="offers-note"
                    >
                        <Info className="h-4 w-4 shrink-0" />
                        Prezzi e disponibilità possono cambiare rapidamente.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
